import './SelectInput.scss'
import React from 'react'
import classnames from 'classnames'

const SelectInput = ({ value, onChange, className, children, autoFocus }) => {
  return (
    <select
      className={classnames('SelectInput', className)}
      onChange={e => onChange(e.target.value)}
      autoFocus={autoFocus ? window.innerWidth > 480 : null}
      value={value}>
      {children}
    </select>
  )
}

SelectInput.displayName = 'SelectInput'

export default SelectInput



// WEBPACK FOOTER //
// ./src/lib/SelectInput.js